import { render, staticRenderFns } from "./DepartModal.vue?vue&type=template&id=b20e765e&scoped=true"
import script from "./DepartModal.vue?vue&type=script&lang=js"
export * from "./DepartModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20e765e",
  null
  
)

export default component.exports